import styled from 'styled-components'

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* Prevents Android touch bleed: when the inner list reaches its edge
     the touch keeps inside (no phantom body scroll), and swipe gestures
     on rows aren't competing with rubber-band on body. */
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`

export default ScrollArea
